export const CrumbTitle = (path) => {
  switch (path) {
    case "users":
      return "Users";
    case "usersdetailed":
      return "User Information";
    case "display":
      return "Display";
    case "forms":
      return "Forms";
    case "results":
      return "Results";
    case "locations":
      return "Locations";
    case "locationdetailed":
      return "Location Information";
    case "featuredgroups":
      return "Featured Groups";
    case "featuredgroupsdetailed":
      return "Featured Group Detailed";
    case "eventsponsors":
      return "Event Sponsors";
    case "eventsponsordetailed":
      return "Event Sponsor Detailed";
    case "eventvenuedetailed":
      return "Event Venue Information";
    case "eventdetailed":
      return "Event Information";
    case "jobgroups":
      return "Job Groups";
    case "jobgroupdetailed":
      return "Job Group Detailed";
    case "managelocations":
      return "Manage Locations";
    case "locatondetailed":
      return "Manage Location Detailed";
    case "trackingpixels":
      return "Tracking Pixels";
    case "trackingpixeldetailed":
      return "Tracking Pixel Detailed";
    case "talentnetworkdisplay":
      return "Talent Network Configuration";
    case "customradius":
      return "Custom Radius";
    case "resultstable":
      return "Results Table";
    case "mapsearchform":
      return "Map Search Form";
    case "featuredadresults":
      return "Featured Ad Results";
    case "featuredjobs":
      return "Featured Jobs";
    case "emailapplylink":
      return "Email Apply Link";
    case "externalaccounts":
      return "External Accounts";
    case "eventvenues":
      return "Event Venues";
    case "featuredevents":
      return "Featured Events";
    case "eventtypes":
      return "Event Types";
    case "mastercache":
      return "Master Cache";
    case "eventsearch":
      return "Event Search";
    case "uploadlocations":
      return "Upload Locations";
    case "jobdetailsdisplay":
      return "Job Details Display";
    case "events":
      return "Events";
    case "prefilteredlinks":
      return "Prefiltered Links";
    case "banner":
      return "Banner";
    case "mapconfiguration":
      return "Map Configuration";
    case "ancillary":
      return "Ancillary";
    case "featuredjobsdisplay":
      return "Featured Jobs Display";
    case "floatingsearchform":
      return "Floating Search Form";
    case "staticsearchform":
      return "Static Search Form";
    case "jobalertsreport":
      return "Job Alerts Report";
    case "reportuser":
      return "User Report";
    case "marketreport":
      return "Marketing Report";
    case "abac":
      return "ABAC Apps";
    default:
      return path;
  }
};
